// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ObjectInspector, chromeDark } from 'react-inspector';

// Import Recoil
import { alertState, personalizationState } from '../../../../recoil-store/recoil-state';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Import Icons
import automEndIcon from '../../../../assets/icons/configurationIcons/autom-end-log-icon.svg';
import showInsideActionIcon from '../../../../assets/icons/configurationIcons/show-inside-of-action-log-icon.svg';
import goBackLogIcon from '../../../../assets/icons/configurationIcons/go-back-log-icon.svg';
import logQuickInfoIcon from '../../../../assets/icons/configurationIcons/log-quick-info-icon.svg';

// Import Helper
import { convertTimestampToDate, convertToDateFormat, formatNanosecondsDifference } from '../../../../helpers/helper';

// Import Pages
import LogService from '../../../../services/LogService/LogService';

// Import Material UI
import { Tooltip } from '@material-ui/core';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';



const LogsDetail = ({ log, setLogs, index, names, img, logTag, info, searchTerm, findedOpetaionGroupIds, handleOpenInfoArea, isHighlight,
    isSelectedGroupLog, handleSelectGroupLog, setOpenEhLogs }) => {
    const [expand, setExpand] = useState(false)
    const [logDetail, setLogDetail] = useState([])
    const [loading, setLoading] = useState(false)
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation();
    const label = "MESSAGES.MONITORING."


    useEffect(() => {
        if (findedOpetaionGroupIds?.length) {
            const isFinded = findedOpetaionGroupIds.find(id => id === log.log_group_id);
            if (isFinded) {
                setExpand(true)
                fetchLogDetails()
                return
            }
        }
        if (expand) {
            setExpand(false)
        }
    }, [findedOpetaionGroupIds, log])

    const fetchLogDetails = async () => {
        setLoading(true)
        const response = await LogService.getLogsByGroupId(log.log_group_id)
        if (response.status) {
            setLogDetail(response.data)
            setLoading(false)
            return response.data
        }
        setLoading(false)
    }

    const handleShowQuickInfo = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleHideQuickInfo = (e) => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl); // Popper'ın açık olup olmadığını kontrol et

    const logRowHtml = () => {
        // debugger;
        if (!log.action_name && logTag) {
            return <span>{logTag}</span>
        }
        else if (log.level === "TRIGGER-PARAM") {
            return ""
        }
        else if (log.action_name) {
            return <>
                <span>
                    {log.library_label.includes('CUSTOM') ? log.library_name :
                        t("CONTENT.LIBRARY." + log.library_name + ".NAME")}
                </span>
                <span className='action-library-name-seperator'> - </span>
                {log.label
                    ? <span>{log.label}</span>
                    : <span>
                        {log?.library_label?.includes('CUSTOM') ? log?.action_name :
                            t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`)}
                    </span>}
            </>
        }
        else if (log.info) {
            return <span>{log.info}</span>
        }
        return ""
    }

    return (<>
        {!logTag
            ? <div className={`log-row-container ${expand ? "bigger-row" : ""} ${log.level?.toLowerCase()}`}
                style={{ boxShadow: isHighlight ? "0 0 2px rgba(255, 140, 0, 0.8), 0 0 6px rgba(255, 140, 0, 0.6),0 0 8px rgba(255, 140, 0, 0.4)" : "0px 0px 4px 0px #00000040" }}>
                <div className="log-row">
                    <div className='group-column'>
                        <span className='index-number' >{index + 1}.</span>
                        <div className={`log-level-column log-${log.level?.toLowerCase()}`}>{t(label + `${log.level}`).toUpperCase()}</div>
                        <img className='log-action-image' src={img} alt='action-image' />
                        <p className='log-action-name' >
                            {logRowHtml()}
                        </p>
                        {log.child_count ? <div className='all-logs-child-count-container'>
                            {log.child_count > 999 ? `+${999}` : log.child_count}
                        </div> : ""}
                        {log.error_handling_executed ? <Tooltip title={t(label + `OPEN-ERROR-HANDLING-LOGS`)} placement="top" >
                            <div className="all-logs-error-handling-button" onClick={() => setOpenEhLogs(log.group_id)} style={{ width: "20px", height: "20px", alignItems: "center" }}>
                                <div className={`error-handling-icon`} >
                                </div>
                            </div>
                        </Tooltip> : ""}
                    </div>
                    {logTag ? <p className='time-of-log'>{log?.created_at ? convertToDateFormat(convertTimestampToDate(log?.created_at), personalization.date_format) : "-"}</p> : ""}
                    <div className='all-logs-log-action-container' >
                        <img alt="log-quick-info-icon" className='all-logs-quick-info-icon' src={logQuickInfoIcon} onClick={() => handleOpenInfoArea(log)} onMouseEnter={handleShowQuickInfo} onMouseLeave={handleHideQuickInfo} />
                        {log.child_count > 0 ? !isSelectedGroupLog
                            ? <img alt="expand-collapse-icon" className='expand-collapse-icon' src={log.child_count > 0 ? showInsideActionIcon : ""}
                                onClick={() => handleSelectGroupLog(log, "next")} />
                            : <img alt="expand-collapse-icon" className='expand-collapse-icon' src={isSelectedGroupLog ? goBackLogIcon : ""}
                                onClick={() => handleSelectGroupLog(log, "back")} /> : isSelectedGroupLog
                            ? <img alt="expand-collapse-icon" className='expand-collapse-icon' src={isSelectedGroupLog ? goBackLogIcon : ""}
                                onClick={() => handleSelectGroupLog(log, "back")} />
                            : ""}
                        <Popper open={open} anchorEl={anchorEl} style={{ minWidth: 213, minHeight: 134 }} transition placement='top'
                            container={document.getElementById("all-operation-eh-log-dialog") ? document.getElementById("all-operation-eh-log-dialog") : document.getElementById("all-operation-log-dialog")} >
                            {({ TransitionProps }) => (
                                <ClickAwayListener onClickAway={() => true}>
                                    <Fade {...TransitionProps} timeout={350}>
                                        <Paper>
                                            <div className="all-logs-quick-info-container">
                                                <div className="all-logs-quick-info-status-container">
                                                    <span className={`all-logs-quick-info-status-text all-log-${log.level === "INFO" ? "success" : log.level?.toLowerCase()}`}>
                                                        {log.level === "INFO" ? t(label + `COMPLETED`) : t(label + `${log.level}`)}
                                                    </span>
                                                    <div className="all-logs-time-elapsed-container">
                                                        <span className="all-logs-time-elapsed">{t(label + 'TIME-ELAPSED')}</span>
                                                        {log.completed_at
                                                            ? <span className={`log-${log.level?.toLowerCase()}`}>{formatNanosecondsDifference(log.created_at, log.completed_at)}</span>
                                                            : "-"}
                                                    </div>
                                                </div>

                                                <div className="all-logs-quick-info-start">
                                                    <div className='all-logs-quick-info-timestamp-header'>
                                                        <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                                                        <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                                    </div>
                                                    <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(log.created_at), personalization.date_format)}</span>
                                                </div>
                                                <div className="all-logs-quick-info-end">
                                                    <div className='all-logs-quick-info-timestamp-header'>
                                                        <img alt="autom-end-icon" src={automEndIcon} className='log-action-image' />
                                                        <span className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                                                    </div>
                                                    {log.completed_at
                                                        ? <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(log.completed_at), personalization.date_format)}</span>
                                                        : "-"}
                                                </div>
                                            </div>
                                        </Paper>
                                    </Fade>
                                </ClickAwayListener>
                            )}
                        </Popper>
                    </div>
                </div>
            </div >
            : <div className='log-started-ended-row'>
                <div className='group-column'>
                    {logTag === "Autom started"
                        ? <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                        : <img alt="autom-end-icon" src={automEndIcon} className='log-action-image' />
                    }
                    <p className='log-action-name'>{info}</p>
                </div>
                <p className='time-of-log'>{log?.created_at ? convertToDateFormat(convertTimestampToDate(log?.created_at), personalization.date_format) : "-"}</p>
            </div>
        }
    </>
    )
}

export default LogsDetail